import axios from "axios";
import { EventosModel, SelectModel } from "../../pages/eventos/models/EventosModel";
const API_URL = process.env.REACT_APP_API;

export async function obtenerEventos() {
  try {
    const response = await axios.get(`${API_URL}eventos`);
    const data = response.data.doc.data;
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
export async function obtenerEventosSelect() {
  try {
    const response = await axios.get(`${API_URL}eventos`);
    const data = response.data?.doc?.data?.rows || [];
    const eventos = data.filter((evento: { status: { code: string } }) => evento.status.code !== "PEND");
    const select: SelectModel[] = eventos.map((item: any) => ({
      id: Number(item.id),
      value: item.id,
      label: `${item.nombre} ${item.status.code === 'ACTIVE' ? '(Activo)' : ''}`,
      data: item,
      actual: item.actual
    }));
    return select;
  } catch (error) {
    console.error("Error en obtenerEventosSelect:", error);
    throw error;
  }
}

export async function obtenerEventosConTicketsSelect() {
  try {
    const response = await axios.get(`${API_URL}eventos/con-tickets`);
    const data = response.data?.doc?.data?.rows || [];
    const select: SelectModel[] = data.map((item: any) => ({
      id: Number(item.id),
      value: item.id,
      label: `${item.nombre} ${item.status?.code === 'ACTIVE' ? '(Activo)' : ''}`,
      data: item,
      actual: item.actual
    }));
    return select;
  } catch (error) {
    console.error("Error en obtenerEventosConTicketsSelect:", error);
    throw error;
  }
}

export async function crearEventoService(evento: EventosModel) {
  try {
    const { id, nombre, fecha_inicio, fecha_fin, imagen, descripcion, ubicacion, organizador_nombre, organizador_imagen, mostrar_menus, mostrar_recargas, visible_app } = evento;
    const url = `${API_URL}eventos${id ? `/${id}` : ''}`;

    const payload = { nombre, fecha_inicio, fecha_fin, imagen, descripcion, ubicacion, organizador_nombre, organizador_imagen, mostrar_menus: mostrar_menus || false, mostrar_recargas: mostrar_recargas || false, visible_app: visible_app !== undefined ? visible_app : true };

    const response = id
      ? await axios.patch(url, payload)
      : await axios.post(url, payload);

    return response;
  } catch (error) {
    console.error('Error en crearEventoService:', error);
    throw error;
  }
}

export async function uploadImagenEvento(file: File) {
  try {
    const formData = new FormData();
    formData.append('imagen', file);

    // Configurar headers para multipart/form-data
    const response = await axios.post(`${API_URL}eventos/upload/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    // Retornamos directamente la data que contiene el payload { imageUrl: ... }
    return response.data;
  } catch (error) {
    console.error('Error al subir la imagen:', error);
    throw error;
  }
}

export async function estatusEventoService(id: number, status_id: number) {
  try {
    const url = `${API_URL}eventos/${id}`;
    const response = await axios.patch(url, { status_id })
    return response;
  } catch (error) {
    console.error('Error en cambiar el estatus del evento:', error);
    throw error;
  }
}
export async function actualEventoService(id: number) {
  try {
    const url = `${API_URL}eventos/${id}`;
    const response = await axios.patch(url, { actual: true })
    return response;
  } catch (error) {
    console.error('Error en cambiar el estatus actual del evento:', error);
    throw error;
  }
}
export async function obtenerEventoPorIDService(id: number) {
  try {
    const response = await axios.get(`${API_URL}/eventos/${id}`);
    let evento = response.data.doc.data;
    evento = {
      ...evento,
      fecha_inicio: new Date(evento.fecha_inicio).toISOString().split('T')[0],
      fecha_fin: new Date(evento.fecha_fin).toISOString().split('T')[0],
    };
    return evento;
  } catch (error) {
    console.log("ERROR: ", error);
    throw error;
  }
}


